const pageNameKey = "timeSeriesDataType";

export const timeSeriesDataTypeEn = {
  [pageNameKey]: {
    dataTypeText: "Data Type",
  },
};

export const timeSeriesDataTypePtBr = {
  [pageNameKey]: {
    dataTypeText: "Tipo de dado",
  },
};

export const timeSeriesDataTypeDe = {
  [pageNameKey]: {
    dataTypeText: "Datenart",
  },
};

export const timeSeriesDataTypeZhHans = {
  [pageNameKey]: {
    dataTypeText: "数据类型",
  },
};

export const timeSeriesDataTypeIt = {
  [pageNameKey]: {
    dataTypeText: "Tipologia dati",
  },
};

export const timeSeriesDataTypeEs = {
  [pageNameKey]: {
    dataTypeText: "Tipo de dato",
  },
};

export const timeSeriesDataTypeNl = {
  [pageNameKey]: {
    dataTypeText: "Gegevenstype",
  },
};

export const timeSeriesDataTypeTr = {
  [pageNameKey]: {
    dataTypeText: "Veri Türü",
  },
};
